// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 4px 12px;
  overflow: hidden;
}

.loading-section {
  flex: 1;
  overflow: hidden;
  padding-top: 8px;
}

app-document-list {
  flex: 1;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/documents-folder/documents-folder.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,OAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,OAAA;EACA,gBAAA;AACJ","sourcesContent":[".page-container {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 4px 12px;\n    overflow: hidden;\n}\n\n.loading-section {\n    flex: 1;\n    overflow: hidden;\n    padding-top: 8px;\n}\n\napp-document-list {\n    flex: 1;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
